<template>
  <div>
    <el-form ref="form" status-icon :model="form" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="22">
          <el-form-item prop="guest_id" size="medium">
            <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block">
              {{ $t("message.guest") }}
            </span>
            <select-guest
              :size="'medium'"
              :id="form.guest_id"
              v-model="form.guest_id"
            ></select-guest>
          </el-form-item>
        </el-col>
        <!-- end col -->
        <el-col :span="2">
          <div class="pulus mts" @click="dialogCreateGuest = true" :class="mode ? 'pulus__myday' : 'pulus__mynight'">
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="number" size="medium">
            <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block">
              {{ $t("message.car_number") }}
            </span>
            <crm-input
            :class="mode ? 'input__day' : 'input__night'"
              :inputValue="form.number"
              v-model="form.number"
              :placeholder="$t('message.car_number')"
            ></crm-input>
          </el-form-item>
        </el-col>
    
        <el-col :span="24">
          <el-form-item prop="color" size="medium">
            <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block">
              {{ $t("message.car_color") }}
            </span>
            <crm-input
            :class="mode ? 'input__day' : 'input__night'"
              :inputValue="form.color"
              v-model="form.color"
              :placeholder="$t('message.car_color')"
            ></crm-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="22">
          <el-form-item prop="guest_car_type_id" size="medium">
            <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block"> {{$t('message.car_type')}}  </span>
            <select-guest-car-type
              :id="form.guest_car_type_id"
              v-model="form.guest_car_type_id"
            ></select-guest-car-type>
          </el-form-item>
        </el-col>
        <!-- end col -->
        <el-col :span="2">
          <div class="pulus mts" @click="dialogCreate = true">
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item prop="guest_car_model_id" size="medium">
            <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block"> {{$t('message.car_model')}} </span>
            <select-guest-car-model
              :guest_car_type_id="form.guest_car_type_id"
              :id="form.guest_car_model_id"
              v-model="form.guest_car_model_id"
            ></select-guest-car-model>
          </el-form-item>
        </el-col>
        <!-- end col -->
        <el-col :span="4">
          <div class="pulus mts" @click="dialogCreateModel = true">
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit(true)">
        Сохранить
      </el-button>
      <el-button type="warning"  @click="closeModal()"> Закрыть </el-button>
    </span>
    <el-dialog
      :visible.sync="dialogCreate"
      width="40%"
      :append-to-body="true"
      center
      ref="dialogCreate"
      :class="mode ? 'dialog__myday' : 'dialog__mynight'"
    >
      <crm-create-car-type
        ref="dialogCreateChild"
        dialog="dialogCreate"
      ></crm-create-car-type>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogCreateModel"
      width="40%"
      :append-to-body="true"
      center
      ref="dialogCreateModel"
      :class="mode ? 'dialog__myday' : 'dialog__mynight'"
    >
      <crm-create-car-model
        :guest_car_type_id="form.guest_car_type_id"
        ref="dialogCreateModelChild"
        dialog="dialogCreateModel"
      ></crm-create-car-model>
    </el-dialog>
     <el-dialog
      :title="$t('message.add_guest')"
      :visible.sync="dialogCreateGuest"
      width="40%"
      :append-to-body="true"
      center
      ref="dialogCreateGuest"
      :class="mode ? 'dialog__myday' : 'dialog__mynight'"
    >
      <crm-create-guest
        ref="dialogCreateGuestChild"
        dialog="dialogCreateGuest"
      ></crm-create-guest>
    </el-dialog>
  </div>
</template>
<script>
import selectGuestCarModel from "@/components/filters/inventory/select-guest-car-model";
import selectGuestCarType from "@/components/filters/inventory/select-guest-car-type";
import CrmCreateCarType from "./crm-car-create-type";
import CrmCreateCarModel from "./crm-car-create-model";
import CrmCreateGuest from "./crm-create-guest";
import { i18n } from "@/utils/i18n";
import dialog from "@/utils/mixins/dialog";
import { mapGetters, mapActions } from "vuex";
export default {
  mixins: [dialog],
  components: {
    CrmCreateCarType,
    CrmCreateCarModel,
    selectGuestCarModel,
    selectGuestCarType,
    CrmCreateGuest
  },
  data() {
    return {
      dialogCreateModel: false,
      dialogCreateGuest: false,
      form: {},
      loadingButton: false,
    };
  },
  props: {
    guest_id: {
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      rules: "guestCar/rules",
      model: "guestCar/model",
      columns: "guestCar/columns",
      mode: "MODE"
    }),
  },
  methods: {
    ...mapActions({
      save: "guestCar/store",
      updateInventory: "guestCar/inventory",
      updateList: "guestCar/index",
      setPagination: "guestCar/setPagination",
      updateSort: "guestCar/updateSort",
      updateFilter: "guestCar/updateFilter",
      updateColumn: "guestCar/updateColumn",
      updatePagination: "guestCar/updatePagination",
    }),
    submit(close = true) {
        
      this.$refs["form"].validate((valid) => {
        console.log(this.form.guest_id);
        if (valid && !this.loadingButton && this.form.guest_id) {
          this.loadingButton = true;
          this.save(this.form)
            .then((res) => {
              this.loadingButton = false;
              this.$alert(res);
              if (res.status == 201) {
                this.form = JSON.parse(JSON.stringify({
                    guest_car_type_id: null,
                    guest_car_model_id: null,
                    guest_id: null,
                    color: null
                }));
                 this.closeModal();
                this.updateInventory();
             
              }
            })
            .catch((err) => {
              this.loadingButton = false;
              this.$alert(err);
            });
        }
      });
    },
     closeModal() {
       this.$emit("closeGustCarCreateModel", false);
    },
  },
};
</script>
